import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import StyledSvgIconWrapper from "./wrappers/StyledSvgIconWrapper";

export const HelpIcon = ({
  monochrome,
  ...props
}: { active?: boolean; monochrome?: boolean; activeColor?: string } & SvgIconProps) => {
  return (
    <StyledSvgIconWrapper {...props} width="30" height="30" viewBox="-4 -4 30 30">
      <svg width="64" height="63" viewBox="0 0 64 63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.0459 35.3875C21.2562 35.3875 23.0479 33.5955 23.0479 31.385C23.0479 29.1745 21.2562 27.3825 19.0459 27.3825C16.8357 27.3825 15.0439 29.1745 15.0439 31.385C15.0439 33.5955 16.8357 35.3875 19.0459 35.3875Z"
          fill="#32B88E"
          className="fill"
        />
        <path
          d="M33.1377 35.3875C35.348 35.3875 37.1397 33.5955 37.1397 31.385C37.1397 29.1745 35.348 27.3825 33.1377 27.3825C30.9275 27.3825 29.1357 29.1745 29.1357 31.385C29.1357 33.5955 30.9275 35.3875 33.1377 35.3875Z"
          fill="#32B88E"
          className="fill"
        />
        <path
          d="M47.0699 35.3875C49.2801 35.3875 51.0719 33.5955 51.0719 31.385C51.0719 29.1745 49.2801 27.3825 47.0699 27.3825C44.8596 27.3825 43.0679 29.1745 43.0679 31.385C43.0679 33.5955 44.8596 35.3875 47.0699 35.3875Z"
          fill="#32B88E"
          className="fill"
        />
        <path
          d="M62 31.1654C62 47.2753 48.9461 60.3308 32.8383 60.3308C27.4092 60.3308 22.3194 58.8436 17.9681 56.2584C15.6128 54.8611 2 60.77 2 60.77C2 60.77 8.1477 46.9459 6.89021 44.5005C4.83433 40.5079 3.66668 35.9664 3.66668 31.1654C3.66668 15.0556 16.7206 2 32.8284 2C48.9361 2 61.99 15.0556 61.99 31.1654H62Z"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : ""}
        />
      </svg>
    </StyledSvgIconWrapper>
  );
};
